import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { List } from 'immutable';
import ReduxRecord from './reduxRecord';
import Item from './Item';
import Stimulus from './Stimulus';
import SessionItemResult from './SessionItemResult';
export var SessionItem = /*#__PURE__*/function (_ReduxRecord) {
  function SessionItem() {
    _classCallCheck(this, SessionItem);
    return _callSuper(this, SessionItem, arguments);
  }
  _inherits(SessionItem, _ReduxRecord);
  return _createClass(SessionItem, [{
    key: "getItem",
    value: function getItem() {
      if (this.item) {
        return Item.create(this.item);
      }
    }
  }, {
    key: "getEntry",
    value: function getEntry() {
      return {
        Stimulus: this.stimulusRecord,
        Item: this.itemRecord
      }[this.type];
    }
  }, {
    key: "getNestedEntries",
    value: function getNestedEntries() {
      var _this = this;
      var fromState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (this.stimulus) {
        if (this.items && !fromState) {
          return this.items;
        }
        var stimulusIdFilter = function stimulusIdFilter(si) {
          return si.get('quizSessionId') === _this.quizSessionId && si.getIn(['stimulus', 'id']) === _this.getIn(['stimulus', 'id']);
        };
        var stimulusKeyFilter = function stimulusKeyFilter(si) {
          return si.get('quizSessionId') === _this.quizSessionId && si.get('stimulusKey') === _this.stimulusKey;
        };

        // fallback to use the stimulus id when stimulusKey is not present
        var filter = this.stimulusKey === null ? stimulusIdFilter : stimulusKeyFilter;
        this.items = this.getState().get('sessionItems').filter(filter).map(function (si) {
          return SessionItem.create(si);
        }).sortBy(function (si) {
          return si.position;
        }).toList();
        return this.items;
      }
      return List();
    }
  }, {
    key: "sessionItemResult",
    get: function get() {
      return SessionItemResult.create(this.getState().getIn(['sessionItemResults', this.id]));
    }
  }, {
    key: "type",
    get: function get() {
      return this.stimulus !== null ? 'Stimulus' : 'Item';
    }
  }, {
    key: "isStimulus",
    get: function get() {
      return this.type === 'Stimulus';
    }
  }, {
    key: "stimulusRecord",
    get: function get() {
      return Stimulus.create(this.stimulus);
    }
  }, {
    key: "itemRecord",
    get: function get() {
      return Item.create(this.item);
    }
  }, {
    key: "hasNestedRecords",
    get: function get() {
      return this.isStimulus;
    }
  }, {
    key: "positionSlots",
    get: function get() {
      // decrement to account for stimulus not being its own sessionItem
      // and the generateDisplayPositions assume each item with nested
      // values does not count itself, but it can't be negative
      var slots = this.displayPositionSlots - 1;
      return slots >= 0 ? slots : 0;
    }
  }, {
    key: "displayPositionSlots",
    get: function get() {
      if (this.isStimulus) {
        return this.getNestedEntries().size;
      }
      return 1;
    }
  }]);
}(ReduxRecord({
  id: null,
  item: {},
  pointsPossible: null,
  position: null,
  quizEntryId: null,
  quizSessionId: null,
  scoringData: {},
  calculatorType: 'none',
  stimulus: null,
  stimulusKey: null,
  bolaPosition: null
}));
export default SessionItem;